import React, { useRef, useState } from 'react';
import { Box, Typography, Button, Tooltip, IconButton, Menu, MenuList, Drawer } from "@mui/material";
import { HelpOutlineOutlined, Logout, WhatsApp } from '@mui/icons-material';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import { useNavigate } from 'react-router-dom';
import { useDispatch,useSelector } from 'react-redux';
import { updateToggleBarActiveTab, updateIsExpanded } from "../redux/toggleBarReducer"
import { DashboardCustomizeOutlined } from '@mui/icons-material';
import MenuIcon from '@mui/icons-material/Menu';
import { Stack } from '@mui/system';
import { MenuItem } from '@mui/base';
import Sidebar from './sidebar';
import { useMediaQuery } from 'react-responsive';
import TransLogo from "../assets/KSKB_Logo_TransparentBG.PNG"
const Header = ({title,color}) => {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleLogout = () => {
        console.log('Logout clicked');
        dispatch(updateToggleBarActiveTab('dashboard'))
        // Clear localStorage
        localStorage.clear();
        navigate('/login');
    };

    const handleWhatsApp = () => {
        const whatsappNumber = "+600166683485"; 
        const whatsappUrl = `https://wa.me/${whatsappNumber}`;
        window.open(whatsappUrl, '_blank');
    };
    const menu_options = [
        {
            label: '',
            items: [
                {
                    label: 'Dashboard',
                    icon: <DashboardCustomizeOutlined sx={{width:"40px",height:"40px",color:"#288d2c" }}/>
                },
                {
                    label: 'Export',
                    icon: 'pi pi-upload'
                }
            ]
        }
    ]
    const isMobile = useMediaQuery({ maxWidth: 600 });
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClose = () => {
        setAnchorEl(null);
    }
    const memberName = localStorage.getItem('membername')
    const showTitle = title && title !== "Koperasi";
    return (
        <Box sx={{ background: 'var(--pallate-green-500, #288d2c)', padding: "16px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <Stack direction="row" sx={{gap:"12px", alignItems: "center"}}>
                {isMobile&&<>
                    <MenuIcon sx={{color:"#FFFFFF"}} onClick={(e)=>setAnchorEl(e.currentTarget)} />
                    
                    <Drawer
                        id="header_menu"
                        anchor = "left"
                        open={open}
                        onClose={()=>handleClose()}
                        PaperProps={{
                            style:{paddingTop:"16px",paddingBottom:"16px",width:"258px"}
                        }}
                    >   
                        <Typography sx={{mb:"1rem",p:"12px 16px",color:"var(--Light-Text-Default-Text, #1E293B)",alignSelf:"stretch",fontSize:"20px",fontStyle:"normal",fontFamily:"inter",fontWeight:500,lineHeight:"28px"}}>
                            Hi, {memberName}
                        </Typography>     
                        <Sidebar isHeaderMenuClicked={true}/>
                        <Box sx={{ p: "12px 16px", mt: 1, display: "flex", flexDirection: "column", gap: 1 }}>
                            <Button
                                variant="outlined"
                                onClick={handleWhatsApp}
                                sx={{
                                    justifyContent: "flex-start",
                                    borderColor: "var(--Pallate-green-400, #4ADE80)",
                                    color: "var(--pallate-green-500, #288d2c)",
                                    textTransform: "none",
                                }}
                            >
                                <WhatsApp sx={{width:"24px",height:"24px",color:color?"var(--pallate-green-500, #288d2c)":"#FFF",marginRight:"8px"}}/> WhatsApp Support
                            </Button>
                            <Button
                                variant="outlined"
                                onClick={() => navigate('/contact_us')}
                                sx={{
                                    justifyContent: "flex-start",
                                    borderColor: "var(--Pallate-green-400, #4ADE80)",
                                    color: "var(--pallate-green-500, #288d2c)",
                                    textTransform: "none",
                                }}
                            >
                               < MailOutlineIcon sx={{width:"24px",height:"24px",color:color?"var(--pallate-green-500, #288d2c)":"#FFF",marginRight:"8px"}}/> Email Support
                            </Button>
                            <Button
                                variant="contained"
                                onClick={handleLogout}
                                sx={{
                                    justifyContent: "flex-start",
                                    background: "var(--pallate-green-500, #288d2c)",
                                    textTransform: "none",
                                    "&:hover": { background: "var(--pallate-green-500, #288d2c)" },
                                }}
                            >
                                Logout
                            </Button>
                        </Box>
                    </Drawer>
                </>}
                <Box sx={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                    <Box sx={{ display: "flex", gap: "12px", alignItems: "center" }}>
                        <Box component="img" sx={{ width: {xs:"26px",md:"32px"}, height: {xs:"26px",md:"32px"} }} src={TransLogo} alt="KSKB Logo" />
                        <Typography sx={{ fontSize: {xs:"10px",md:"14px"}, fontWeight: 600, lineHeight: "28px", color: "#fff" }}>
                            KOPERASI SERBAGUNA KEBANGSAAN BERHAD (4391)
                        </Typography>
                    </Box>
                    {/* {showTitle && (
                        <Typography sx={{ fontSize: "16px", fontWeight: 600, lineHeight: "20px", color: "#fff" }}>
                            {title}
                        </Typography>
                    )} */}
                </Box>
            </Stack>
        {!isMobile && (
            <Box sx={{display:"flex"}}>
                <Tooltip title="WhatsApp Support" arrow>
                    <IconButton
                    sx={{ display:"flex",padding:"8px",alignItems:"flex-start",gap:"10px",borderRadius:"20px",border:"1px solid var(--Pallate-green-400, #4ADE80)",background:"var(--Pallate-green-500, #288d2c)", mr: 1}}
                    onClick={handleWhatsApp}
                    >
                    <WhatsApp sx={{width:"24px",height:"24px",color:"#FFF"}}/>
                    </IconButton>
                </Tooltip>
                <Tooltip title="Email Support" arrow>
                    <IconButton
                    sx={{ "&:hover":{background:color?"#FFF":"var(--Pallate-green-500, #288d2c)"},display:"flex",padding:"8px",alignItems:"flex-start",gap:"10px",borderRadius:"20px",border:"1px solid var(--Pallate-green-400, #4ADE80)",background:color?"#FFF":"var(--Pallate-green-500, #288d2c)"}}
                    onClick={()=> navigate('/contact_us')}
                    >
                    <MailOutlineIcon sx={{width:"24px",height:"24px",color:color?"var(--pallate-green-500, #288d2c)":"#FFF"}}/>
                    </IconButton>
                </Tooltip>
                <Tooltip title="Logout" arrow>
                    <Button
                    sx={{ color: "#fff" }}
                    onClick={handleLogout}
                    >
                    <Logout />
                    </Button>
                </Tooltip>
            </Box>
        )}
        </Box>
    );
};

export default Header;